// From https://ourcodeworld.com/articles/read/189/how-to-create-a-file-and-generate-a-download-with-javascript-in-the-browser-without-a-server
function downloadVCard(filename, text) {
    var element = document.createElement('a');
    element.setAttribute(
        'href',
        'data:text/vcard;charset=utf-8,' + encodeURIComponent(text)
    );
    element.setAttribute('download', filename);

    element.style.display = 'none';

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

$('.vcardExport').on('click', function (e) {
    downloadVCard($(this).attr('data-name'), $(this).attr('data-content'));
});
